<div class="header" id="header-container" [ngClass]="{'is-mac': isMacOS()}">
    <div class="left">
        <div class="menu-button-wrapper" *ngIf="this.selected !== 'inGame'">
            <div class="menu-button clickable" (click)="toggleMenu()">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
            </div>
        </div>
        <div class="player-info-wrapper">
            <app-player-info></app-player-info>
        </div>
    </div>
    <div class="center">
        @if (isDesktop()) {
            <div class="currency-wrapper" [appSopoTooltip]="tooltips().gold">
                <img id="homepage-gold" class="currency-icon" src="/assets/icon/chips/gold_chip.webp">
                <div class="currency-number">
                    @for (gold of golds(); track gold.id) {
                        <div @roll class="currency-value">{{ gold.value | numberSuffix:'1.0-2' }}</div>
                    }
                </div>
                <div class="currency-text">GC</div>
            </div>
            @if (sweepbuckEnabled()) {
                <div id="home-sweepbuck" class="currency-wrapper" [appSopoTooltip]="tooltips().sweepsbuck">
                    <img id="homepage-sweepbuck" class="currency-icon" src="assets/img/sweep/money.webp">
                    <div class="currency-number">
                        @for (sweepbuck of sweepbucks(); track sweepbuck.id) {
                            <div @roll class="currency-value">{{ sweepbuck.value | numberSuffix:'1.0-2' }}</div>
                        }
                    </div>
                    <div class="currency-text">SC</div>
                </div>
                <div class="currency-wrapper" [appSopoTooltip]="tooltips().jackpotTicket">
                    <img id="homepage-jackpotTicket" class="currency-icon" src="assets/img/sweep/gold_ticket.webp">
                    <div class="currency-number">
                        @for (jackpotTicket of jackpotTickets(); track jackpotTicket.id) {
                            <div @roll class="currency-value">{{ jackpotTicket.value | numberSuffix:'1.0-2' }}</div>
                        }
                    </div>
                    <div class="currency-text">TIX</div>
                </div>
            }
        }
    </div>
    <div class="right">
        <div
            *ngIf="isUpdateAvailable()"
            class="update clickable"
            (click)="updateService.promtForUpdateConfirm()"
        >
            <ion-icon name="refresh-outline"></ion-icon>
            Update
        </div>
        <div class="download">
            <img
                class="badge clickable"
                src="../../../../assets/img/header/play-store-badge.webp"
                alt="Play store"
                (click)="openLink('https://play.google.com/store/apps/details?id=software.odysseus.sopo')"
            />
            <img
                class="badge"
                src="../../../../assets/img/header/app-store-badge.webp"
                alt="App store"
                (click)="openLink('https://apps.apple.com/us/app/sopo-social-poker/id1441432679')"
            />
        </div>
        <img class="glc">
        <img class="cfg clickable" src="../../../../assets/img/cfg.png" alt="Certified fair" (click)="showCertificate()">
    </div>
    <ng-template #sopoMenu></ng-template>
</div>
<div class="subheader" *ngIf="showSubheader()" [ngClass]="{ 'lobby-home': isInLobbyHome() }">
    <app-tab-selector></app-tab-selector>
</div>
